/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CapacityTemplateGroupModel as DigiworkMaitreDPosDtoPosCapacityTemplateGroupModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Pos/capacity-template-group-model';

export interface AddVenue$Params {
      body?: {
'Name'?: string;
'Address'?: string;
'Phone'?: string;
'VenueImageFile'?: Blob;
'Capacity.Id'?: string;
'Capacity.Name'?: string;
'Capacity.Description'?: string;
'Capacity.VenueId'?: string;
'Capacity.IsDefault'?: boolean;
'Capacity.CapacityGroups'?: Array<DigiworkMaitreDPosDtoPosCapacityTemplateGroupModel>;
'FiscalPrinterCode'?: string;
}
}

export function addVenue(http: HttpClient, rootUrl: string, params?: AddVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, addVenue.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

addVenue.PATH = '/api/gmn/Venue/addvenue';
